import './contact.css';
import { FaUser, FaEnvelope, FaPhone, FaComment } from 'react-icons/fa';
import { useState } from 'react';
import { toast } from 'react-hot-toast';
import { apiFetch, MAIL_URL } from '../api';

const ContactForm = () => {
    const [form, setForm] = useState({ name: '', email: '', phone: '', message: '' });
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);

    const getAuth = () => {
        const user = JSON.parse(localStorage.getItem('user') || 'null');
        const token = localStorage.getItem('token');
        const userId = user ? (user.id || user._id) : null;
        return { userId, token };
    };

    const validate = () => {
        const newErrors = {};
        if (!form.name) newErrors.name = "Please fill the Name";
        else if (!/^[a-zA-Z\s]+$/.test(form.name)) newErrors.name = "Name only contains letters";
        if (!form.email) newErrors.email = "Please fill the Email";
        else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) newErrors.email = "Please enter a valid email address";
        if (!form.phone) newErrors.phone = "Please fill the Phone";
        if (!form.message) newErrors.message = "Please fill the Message";
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
        if (errors[e.target.name]) {
            setErrors({ ...errors, [e.target.name]: "" });
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validate()) return;

        const { userId } = getAuth();
        if (!userId) {
            toast.error("Please log in to submit a contact form.");
            return;
        }

        setIsLoading(true);
        try {
            const payload = {
                user: userId, name: form.name, email: form.email,
                phone: form.phone, message: form.message,
            };

            const data = await apiFetch('/api/reports/create', {
                method: 'POST',
                body: payload,
                baseUrl: MAIL_URL,
            });

            toast.success(data.message || "Message sent successfully!", { position: "top-center" });
            setForm({ name: '', email: '', phone: '', message: '' });
        } catch (err) {
            console.error("Submission Error:", err);
            toast.error(`Error: ${err.message || 'Server error'}.`, { position: "top-center" });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="container-fluid py-4 contact-container">
            <div className="row w-100 justify-content-center">
                <div className="col-12 col-lg-10 col-xl-8">
                    <div className="card shadow-lg border-0 contact-card">
                        <div className="card-border-animation"></div>
                        <div className="row g-0">
                            <div className="col-md-6">
                                <div className="h-100 map-container">
                                    <div className="map-overlay justify-content-end align-items-center d-flex flex-column text-center p-4">
                                       <strong> <h3>Visit Our Location</h3>
                                        <p>Aadvi The Fashion Institute</p></strong>
                                    </div>
                                    <iframe 
                                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3916.5624998903213!2d77.27906888885497!3d10.996358299999997!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba9abe302afc90f%3A0x83351aa18a12f76b!2sAadvi%20The%20Fashion%20Institute!5e0!3m2!1sen!2sin!4v1757654352615!5m2!1sen!2sin" 
                                        style={{ border: 0, width: '100%', height: '100%', minHeight: '400px' }} 
                                        allowFullScreen="" 
                                        loading="lazy" 
                                        referrerPolicy="no-referrer-when-downgrade" 
                                        title="Location Map"
                                    ></iframe>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="p-4 p-md-5 slide-in">
                                    <div className="form-header">
                                        <h2 className="mb-3 position-relative text-center text-md-start">Get In Touch</h2>
                                        <p className="text-muted mb-4">We'd love to hear from you. Send us a message and we'll respond as soon as possible.</p>
                                    </div>
                                    <form onSubmit={handleSubmit}>
                                        <div className="mb-3 input-group input-animation">
                                            <span className="input-group-text"><FaUser /></span>
                                            <input type="text" className="form-control contact-input" name="name" value={form.name} onChange={handleChange} placeholder="Enter your Name" />
                                            <div className="input-border"></div>
                                        </div>
                                        {errors.name && <div className="error-message">{errors.name}</div>}
                                        
                                        <div className="mb-3 input-group input-animation">
                                            <span className="input-group-text"><FaEnvelope /></span>
                                            <input type="email" className="form-control contact-input" name="email" value={form.email} onChange={handleChange} placeholder="Enter your Email" />
                                            <div className="input-border"></div>
                                        </div>
                                        {errors.email && <div className="error-message">{errors.email}</div>}
                                        
                                        <div className="mb-3 input-group input-animation">
                                            <span className="input-group-text"><FaPhone /></span>
                                            <input type="tel" className="form-control contact-input" name="phone" value={form.phone} onChange={handleChange} placeholder="Enter your Phone Number" />
                                            <div className="input-border"></div>
                                        </div>
                                        {errors.phone && <div className="error-message">{errors.phone}</div>}
                                        
                                        <div className="mb-4 input-group input-animation">
                                            <span className="input-group-text"><FaComment /></span>
                                            <textarea className="form-control contact-input" name="message" value={form.message} onChange={handleChange} placeholder="Your Message" rows="5"></textarea>
                                            <div className="input-border"></div>
                                        </div>
                                        {errors.message && <div className="error-message">{errors.message}</div>}
                                        
                                        <button type="submit" className="btn text-light w-100 py-3 contact-btn" disabled={isLoading}>
                                            {isLoading ? (
                                                <div className="btn-loading">
                                                    <div className="btn-spinner"></div>
                                                    Sending...
                                                </div>
                                            ) : (
                                                'Send Message'
                                            )}
                                        </button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ContactForm;